import { render, staticRenderFns } from "./RawTable.vue?vue&type=template&id=71a93a1c&scoped=true&"
import script from "./RawTable.vue?vue&type=script&lang=js&"
export * from "./RawTable.vue?vue&type=script&lang=js&"
import style0 from "./RawTable.vue?vue&type=style&index=0&id=71a93a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a93a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VSpacer,VTextField,VToolbar,VToolbarTitle})
